import { type FC } from "react";

import { GoalFieldIdentifier, TPFieldType, type TPFieldTypeValue } from "@pages/Templates/constants";

const TYPE_LABELS: Record<TPFieldTypeValue, string> = {
  [TPFieldType.GOAL]: "Goal",
  [TPFieldType.TARGET]: "Target",
};

/** Shared wording for the Programming-save and publish warnings. */
export const ProgressSummaryMissingText: FC<{ missingTypes: readonly TPFieldTypeValue[] }> = ({ missingTypes }) => {
  const labels = missingTypes.map((type) => TYPE_LABELS[type]);
  return (
    <>
      This reassessment template has no {labels.join(" and ")} Progress Summary field. Saved progress summaries
      won&apos;t show on Programming, Review, or the download. To add it, add a default {labels.join(" or ")} field with
      the key <span className="font-mono">{GoalFieldIdentifier.PROGRESS_SUMMARY}</span> on the Programming tab. If it
      shouldn&apos;t show, add it and turn it off instead of leaving it out.
    </>
  );
};
